<template>
<div>
    <label>{{ label }}</label>
    <div class="fg-line form-group">
        <select v-model="new_option" class="form-control">
            <option disabled="true">{{ placeholder_value }}</option>
            <option v-for="option in option_list" :value="option"
            :disabled="selected_option_ids.indexOf(option[value_field]) != -1">
            {{ option[caption_field] }}
            </option>
        </select>
    </div>

    <div  v-if="selected_option_list">
        <ul class="option-list">
            <li v-for="(option,index) in selected_option_list">
                <button type="button" class="text-gray-drk" @click="removeOption(index)" tabindex="-1">
                <i class="fa fa-close" style="color:#f32c1e" aria-hidden="true"></i>
                </button>
                {{ option[caption_field] }}
            </li>
        </ul>
    </div>
</div>
</template>
<style lang="scss">
  @import '../../sass/_global_variables.scss';

  .option-list {
    list-style: none;
    padding-left: 0px;
  }


</style>
<script type="text/ecmascript-6">
  export default {
    props: {
      option_list: {
        type: Array,
        default: function () {
          return []
        }
      },
      placeholder_value: {default: 'Select Option'},
      value_field: {default: 'id'},
      caption_field: {default: 'caption'},
      limit: {default: 0},
      label: {default: ''},
    },
    data: function () {
      return {
        selected_option_list: [],
        new_option: false,
        errors: [],
      }
    },


    methods: {
      addOption(option) {
        if ((this.limit > 0) && (this.selected_option_list.length >= this.limit)) {
          sweetAlert('', 'You have reached the limit for ' + this.label, 'warning');
          this.new_option = false;
          return
        }
        if (!option || !option[this.value_field]) {
          return
        }

        // Check if the test is already in the list of tests
        if (this.selected_option_ids.includes(option[this.value_field])) {
          this.new_option = false;
        } else {
          this.selected_option_list.push(option);
          this.new_option = false;
          this.save();
        }
      },
      removeOption(option_index) {
        this.selected_option_list.splice(option_index, 1);
        this.save();
      },
      save() {
        this.$emit('save', this.selected_option_ids);
      }


    }
    ,
    computed: {

      selected_option_ids() {
        return this.selected_option_list.map(option => {
          return option[this.value_field]
        });
      },
    },

    mounted() {

      this.new_option = this.placeholder_value;
    }
    ,
    watch: {

      new_option: {
        handler() {
          if (this.new_option) {
            this.addOption(this.new_option);
          }
        },
        deep: true
      },
    }
  }
</script>



// WEBPACK FOOTER //
// multi-select-list.vue?d2cb9b08